export default "__VITE_ASSET__DObKwzxW__"